<template>
  <div class="form-dialog">
    <div class="form-body-scroll">
      <div
        class="form-title padding-title"
        v-text="'Cotización'"
      />
      <div class="form-box-body">
        <vuescroll>
          <div class="form-components scroll">
            <div
              class="form_combo_text"
              v-text="text"
            />

            <div
              class="form_label"
              v-text="'Ingresa tu Nombre y Apellido *'"
            />
            <div class="form__field">
              <label
                for="nombre"
              ><v-icon
                name="user"
                scale="1"
                style="margin: 1px 1px 0"
              /></label>
              <input
                id="nombre"
                ref="nombre"
                v-model="nombre"
                autocomplete="off"
                type="text"
                name="nombre"
                value=""
                placeholder=""
                required
                @focus="_clearError"
                @keyup.enter="focusTo('email')"
                @keypress="keyPressCheckSpecialChars($event, 'name')"
                @change="cleanSpecialChars('nombre', 'name')"
              >
            </div>

            <div
              class="form_label"
              v-text="'Ingresa tu email *'"
            />
            <div class="form__field">
              <label
                for="email"
              ><v-icon
                name="envelope"
                scale="1"
                style="margin-top: 2px"
              /></label>
              <input
                id="email"
                ref="email"
                v-model="email"
                class="email"
                autocomplete="off"
                type="text"
                name="email"
                value=""
                placeholder="usuario@dominio.com"
                required
                @focus="_clearError"
                @keyup.enter="focusTo('telefono')"
                @keypress="keyPressCheckSpecialChars($event, 'email')"
                @change="cleanSpecialChars('email', 'email')"
              >
            </div>

            <div
              class="form_label"
              v-text="'Teléfono de contacto *'"
            />
            <div class="form__field">
              <label
                for="telefono"
              ><v-icon
                name="mobile-alt"
                scale="1"
                style="margin: 0 2px 3px 4px"
              /></label>
              <input
                id="telefono"
                ref="telefono"
                v-model="telefono"
                autocomplete="off"
                type="text"
                name="telefono"
                value=""
                placeholder="+569 1 234 5678"
                required
                @focus="_clearError"
                @keyup.enter="focusTo('rut')"
                @keypress="keyPressCheckSpecialChars($event, 'phone')"
                @change="cleanSpecialChars('telefono', 'phone')"
              >
            </div>

            <div
              class="form_label"
              v-text="'RUT *'"
            />
            <div class="form__field">
              <label
                for="rut"
              ><v-icon
                name="address-card"
                scale="1"
                style="margin-top: 3px"
              /></label>
              <input
                id="rut"
                ref="rut"
                v-model="rut"
                autocomplete="off"
                type="text"
                name="rut"
                value=""
                placeholder="XX.XXX.XXX-X"
                required
                @focus="_clearError"
                @keyup.enter="focusTo('producto')"
                @keypress="keyPressCheckSpecialChars($event, 'rut')"
                @change="_formatearRut($event.target.value)"
              >
            </div>

            <div
              class="form_label"
              v-text="'Producto'"
            />
            <select
              id="form_estilos"
              v-model="producto"
              :multiple="false"
              class="formulario_combo"
              @change="_seleccionProducto($event.target.value)"
            >
              <option value="">
                Seleccione tipo de producto
              </option>
              <option value="Mascarillas">
                Mascarillas
              </option>
              <option value="Bolsas">
                Bolsas
              </option>
            </select>

            <template v-if="producto === 'Mascarillas'">
              <div
                class="form_label"
                v-text="'Tipo'"
              />
              <select
                id="form_estilos"
                v-model="tipo"
                :multiple="false"
                class="formulario_combo"
                @change="_seleccionTipo($event.target.value)"
              >
                <option value="">
                  Seleccione tipo
                </option>
                <option value="Nanocobre">
                  Nanocobre
                </option>
                <option value="Sin nanocobre">
                  Sin nanocobre
                </option>
              </select>

              <div
                class="form_label"
                v-text="'Cantidad'"
              />
              <div class="form__field">
                <label
                  for="cantidad"
                ><v-icon
                  name="file"
                  scale="1"
                  style="margin: 1px 2px 0 4px"
                /></label>
                <input
                  id="cantidad"
                  ref="cantidad"
                  v-model="cantidad"
                  autocomplete="off"
                  type="text"
                  name="cantidad"
                  value=""
                  placeholder="Cantidad"
                  required
                  @focus="_clearError"
                  @keypress="onlyNumbers($event)"
                  @change="cleanSpecialChars('cantidad', 'cantidad')"
                >
              </div>
            </template>

            <template v-if="producto === 'Bolsas'">
              <div
                class="form_label"
                v-text="'Tipo'"
              />
              <select
                id="form_estilos"
                v-model="tipo"
                :multiple="false"
                class="formulario_combo"
                @change="_seleccionTipo($event.target.value)"
              >
                <option value="">
                  Seleccione tipo
                </option>
                <option value="Promocional">
                  Bolsa promocional
                </option>
                <option value="Boutique">
                  Bolsa boutique
                </option>
                <option value="Algodón">
                  Bolsa algodón
                </option>
              </select>
            </template>

            <template v-if="tipo === 'Promocional' || tipo === 'Boutique'">
              <div
                class="form_label"
                v-text="'Material'"
              />
              <select
                id="form_estilos"
                v-model="material"
                :multiple="false"
                class="formulario_combo"
                @change="_seleccionMaterial($event.target.value)"
              >
                <option value>
                  Seleccione material
                </option>
                <option value="TNT">
                  TNT
                </option>
                <option value="Vegetal">
                  Vegetal
                </option>
              </select>

              <div
                class="form_label"
                v-text="'Medidas'"
              />
              <select
                id="form_estilos"
                v-model="medida"
                :multiple="false"
                class="formulario_combo"
                @change="_seleccionMedida($event.target.value)"
              >
                <option value="">
                  Seleccione medida
                </option>
                <option value="Pequeña">
                  Pequeña
                </option>
                <option value="Mediana">
                  Mediana
                </option>
                <option value="Grande">
                  Grande
                </option>
              </select>

              <div
                class="form_label"
                v-text="'Cantidad'"
              />
              <div class="form__field">
                <label
                  for="cantidad"
                ><v-icon
                  name="file"
                  scale="1"
                  style="margin: 1px 2px 0 4px"
                /></label>
                <input
                  id="cantidad"
                  ref="cantidad"
                  v-model="cantidad"
                  autocomplete="off"
                  type="text"
                  name="cantidad"
                  value=""
                  placeholder="Cantidad"
                  required
                  @focus="_clearError"
                  @keypress="onlyNumbers($event)"
                  @change="cleanSpecialChars('cantidad', 'cantidad')"
                >
              </div>
            </template>

            <template v-if="tipo === 'Algodón'">
              <div
                class="form_label"
                v-text="'Medidas'"
              />
              <select
                id="form_estilos"
                v-model="medida"
                :multiple="false"
                class="formulario_combo"
                @change="_seleccionMedida($event.target.value)"
              >
                <option value="">
                  Seleccione medida
                </option>
                <option value="30x35">
                  30x35
                </option>
                <option value="38x42">
                  38x42
                </option>
                <option value="40x40x20">
                  40x40x20
                </option>
                <option value="38x38">
                  38x38
                </option>
              </select>

              <div
                class="form_label"
                v-text="'Cantidad'"
              />
              <div class="form__field">
                <label
                  for="cantidad"
                ><v-icon
                  name="file"
                  scale="1"
                  style="margin: 1px 2px 0 4px"
                /></label>
                <input
                  id="cantidad"
                  ref="cantidad"
                  v-model="cantidad"
                  autocomplete="off"
                  type="text"
                  name="cantidad"
                  value=""
                  placeholder="Cantidad"
                  required
                  @focus="_clearError"
                  @keypress="onlyNumbers($event)"
                  @change="cleanSpecialChars('cantidad', 'cantidad')"
                >
              </div>
            </template>
          </div>
        </vuescroll>
      </div>

      <!-- BOTONES -->
      <div class="form-box-button scroll margin_btn">
        <button
          class="button-secondary"
          @click="_cancelClick"
        >
          Cancelar
        </button>
        <button
          class="button-primary"
          @click="_sentClick"
        >
          Enviar
        </button>
      </div>
      <!-- MSG -->
      <div class="form-error">
        &nbsp;{{ errormsg }}
      </div>
    </div>
  </div>
</template>
<script>
import { serverUI } from './main'
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/user'
import 'vue-awesome/icons/lock'
import 'vue-awesome/icons/comment'
import 'vue-awesome/icons/calendar'
import 'vue-awesome/icons/envelope'
import 'vue-awesome/icons/box'
import 'vue-awesome/icons/list-ol'
import utils from './utils'

export default {
  components: {
    'v-icon': Icon
  },
  props: {},
  data () {
    return {
      title: '',
      text: '',
      errormsg: '',
      nombreOrigen: '',
      emailOrigen: '',
      telefonoOrigen: '',
      nombre: '',
      email: '',
      rut: '',
      telefono: '',
      producto: '',
      tipo: '',
      cantidad: '',
      material: '',
      medida: ''
    }
  },
  computed: {},
  created () {
    // Señales recibidas
    serverUI.$on('FormEvent', (e) => {
      if (e.form !== 'UNIBAGCotizarForm') return
      if (e.evento === 'init') {
        // console.log("asigna por init:");
        // console.log("e.dato:",e.dato);
      }
      if (e.evento === 'newdata') {
        // console.log("asigna por newdata:");
        // console.log("e.dato:",e.dato);
        this.text = e.dato.text ? e.dato.text : ''
        this.nombreOrigen = e.dato.fields.name ? e.dato.fields.name : ''
        this.emailOrigen = e.dato.fields.email ? e.dato.fields.email : ''
        this.telefonoOrigen = e.dato.fields.phone ? e.dato.fields.phone : ''

        this.nombre = this.nombreOrigen
        this.email = this.emailOrigen
        this.telefono = this.telefonoOrigen
        // this.rut = this.rut
        this.producto = e.dato.fields.producto ? e.dato.producto : ''
        this.tipo = e.dato.fields.tipo ? e.dato.tipo : ''
        // this.cantidad = this.cantidad
        this.material = e.dato.fields.tipo ? e.dato.tipo : ''
        this.medida = e.dato.fields.tipo ? e.dato.tipo : ''
      }
    })
  },
  methods: {
    _clearError () {
      this.errormsg = ''
    },
    focusTo (el) {
      if (el === 'pass') this.$refs.password.focus()
    },
    _formatearRut (val) {
      this.rut = utils.cleanSpecialChars(val, 'rut')
      this.rut = utils.formatearRut(this.rut)
    },
    keyPressCheckSpecialChars (evt, type) {
      return utils.keyPressCheckSpecialChars(evt, type)
    },
    onlyNumbers (evt) {
      return utils.onlyNumbersInput(evt)
    },
    _seleccionProducto () {
      this.errormsg = ''
    },
    _seleccionTipo () {
      this.errormsg = ''
    },
    _seleccionMaterial () {
      this.errormsg = ''
    },
    _seleccionMedida () {
      this.errormsg = ''
    },
    cleanSpecialChars (val, type) {
      if (!val) return
      return (this[val] = utils.cleanSpecialChars(this[val], type))
    },
    _sentClick () {
      this.errormsg = ''
      if (!this.nombre) {
        this.errormsg = 'Debes ingresar nombre'
        return
      }
      if (!this.email) {
        this.errormsg = 'Debes ingresar email'
        return
      }
      if (!utils.isEmail(this.email)) {
        this.errormsg = 'Formato email incorrecto'
        return
      }
      if (!this.telefono) {
        this.errormsg = 'Debes ingresar teléfono'
        return
      }
      if (this.rut === '') {
        this.$refs.rut.focus()
        this.errormsg = 'Debes ingresar tu rut'
        return
      }
      if (!utils.validaRut(this.rut)) {
        this.$refs.rut.focus()
        this.errormsg = 'Debes ingregar RUT válido'
        return
      }
      if (!this.producto) {
        this.errormsg = 'Debes ingresar un producto'
        return
      }
      if (!this.tipo) {
        this.errormsg = 'Debes ingresa el tipo a cotizar'
        return
      }
      if (!this.cantidad) {
        this.errormsg = 'Debes ingresar la cantidad a cotizar'
        return
      }
      if (this.producto === 'Mascarillas' && this.cantidad <= 499) {
        this.errormsg = 'Debe ser una cantidad mayor o igual a 500 mascarillas'
        this.material = ''
        return
      }
      if (this.producto === 'Bolsas' && (this.tipo === 'Promocional' || this.tipo === 'Boutique') && this.cantidad <= 1999) {
        this.errormsg = 'Debe ser una cantidad mayor o igual a 2000 bolsas'
        return
      }
      if (this.producto === 'Bolsas' && this.tipo === 'Algodón' && this.cantidad <= 499) {
        this.errormsg = 'Debe ser una cantidad mayor o igual a 500 bolsas'
        this.material = 'Algodón'
        return
      }
      let dataToSend = {
        form: 'UNIBAGCotizarForm',
        evento: 'sentClick',
        data: {
          fields: {
            email: this.email,
            firstname: this.nombre,
            phone: this.telefono,
            rut: this.rut,
            producto: this.producto
          }
        }
      }
      if (this.producto === 'Mascarillas') {
        dataToSend = {
          form: 'UNIBAGCotizarForm',
          evento: 'sentClick',
          data: {
            fields: {
              ...dataToSend.data.fields,
              tipo: this.tipo,
              cantidad: this.cantidad
            }
          }
        }
      }
      if (this.producto === 'Bolsas' && this.tipo === 'Algodón') {
        if (!this.medida) {
          this.errormsg = 'Debe ingresar un medida'
          return
        }
        dataToSend = {
          form: 'UNIBAGCotizarForm',
          evento: 'sentClick',
          data: {
            fields: {
              ...dataToSend.data.fields,
              tipo: this.tipo,
              cantidad: this.cantidad,
              medida: this.medida
            }
          }
        }
      }
      if (this.producto === 'Bolsas' && (this.tipo === 'Promocional' || this.tipo === 'Boutique')) {
        if (!this.material) {
          this.errormsg = 'Debe ingresar un material'
          return
        }
        if (!this.medida) {
          this.errormsg = 'Debe ingresar un medida'
          return
        }
        dataToSend = {
          form: 'UNIBAGCotizarForm',
          evento: 'sentClick',
          data: {
            fields: {
              ...dataToSend.data.fields,
              tipo: this.tipo,
              material: this.material,
              medida: this.medida,
              cantidad: this.cantidad
            }
          }
        }
      }

      dataToSend.data.type = 'unibag-cotizar-form-confirm'

      serverUI.$emit('FormEvent', dataToSend)
    },
    _cancelClick () {
      serverUI.$emit('FormEvent', {
        form: 'UNIBAGCotizarForm',
        evento: 'cancelClick',
        dato: 'Cancelado'
      })
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
.form__field {
  margin-bottom: 7px;
}

.form-box-body {
  height: 335px;
}
</style>
